























































import Vue from "vue";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import moment from "moment";

export default Vue.extend({
  name: "ReportPdf",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, required: true },
    reportDate:{type: String, required: true},
    reportRangeDate: {type: String, required: true},
    medicalOffice: { type: String, required: true },
    //dateRange: { type: String, required: true },
    filterByDate: { type: String, required: true },
    columns: { type: Array, required: true },
    columnMap: { type: Object, required: true },
    rows: { type: Array, required: true },
    footer: { type: Array, default: () => [] },
    fileName: { type: String, default: "reporte.pdf" },
    logo: { type: String, default: "" },
  },
  methods: {
    formattedValue(col: string, row: any) {
    if (col === 'Date') {
      return moment(row.Date).format('MM/DD/YYYY');
    } else if (col === 'RecordDate') {
      return moment(row.RecordDate).format('MM/DD/YYYY hh:mm A');
    } else if (col === 'Time') {
      return row.Time ? moment(row.Time, "HH:mm").format("hh:mm A") : row.SessionName;
    } else {
      return row[col];
    }

  },
    async exportPDF() {
      //const el = this.$refs.report;
      // esperar un tick para asegurar que el DOM se renderizó
      await this.$nextTick();
      const el = this.$refs.report as HTMLElement;
      if (!el) {
        console.error("Elemento report no encontrado");
        return;
      }

      

      try {
        const canvas = await html2canvas(el, {
          scale: 2,
          useCORS: true,
          allowTaint: true
        });

        const imgData = canvas.toDataURL("image/png");
        /*const pdf = new jsPDF("p", "mm", "a4");*/
        // Conversión px -> mm (aprox. 96dpi)
    const mmPerPx = 25.4 / 96;
    const pageWidthMM = Math.round(canvas.width * mmPerPx);
    const pageHeightMM = Math.round(canvas.height * mmPerPx);

    // Crear PDF con tamaño EXACTO del canvas
    const pdf = new jsPDF({ unit: "mm", format: [pageWidthMM, pageHeightMM], orientation: "p" });
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save(this.fileName);
      } catch (err) {
        console.error("Error generando PDF:", err);
      }
    
      
    },
  },
});
